import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ProseProps {
    html: string
    className?: string
}

// Renders trusted, editor-authored HTML stored in the database.
// Content is created by the team via the data layer, not by site visitors.
export const Prose: FC<ProseProps> = ({ html, className }): ReactNode => {
    return (
        <div
            className={cn(
                'prose prose-neutral max-w-none',
                'prose-headings:font-heading prose-headings:font-semibold prose-headings:tracking-tight',
                'prose-h2:mb-3 prose-h2:mt-10 prose-h2:text-2xl',
                'prose-p:leading-relaxed prose-p:text-foreground/85',
                'prose-li:my-1 prose-li:text-foreground/85 prose-ul:my-4',
                'prose-strong:text-foreground prose-a:font-medium prose-a:text-primary',
                'prose-blockquote:border-l-primary prose-blockquote:font-normal prose-blockquote:not-italic prose-blockquote:text-muted-foreground',
                className
            )}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    )
}
